import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './chat-bubble.style'

const ChatBubble = props => {
  const classes = useStyles(props)

  const { children } = props

  return <div className={classes.bubble}>{children}</div>
}

ChatBubble.propTypes = {
  children: PropTypes.node.isRequired,
  isMe: PropTypes.bool.isRequired
}

export default ChatBubble
